import axios from "axios";
import { API } from "./constants";

const getStoredCustomActivities = (userId) => {
  try {
    const saved = localStorage.getItem('mygoal-custom-activities');
    const customActivities = saved ? JSON.parse(saved) : [];
    return customActivities.filter((activity) => !activity.created_by || activity.created_by === userId);
  } catch (error) {
    console.error('Failed to read custom activities for session repair:', error);
    return [];
  }
};

const buildCustomActivityRepairItems = (userId) => {
  return getStoredCustomActivities(userId)
    .filter((activity) => activity?.id && activity?.date)
    .map((activity) => {
      const [year, month, day] = activity.date.split('-').map(Number);
      const [hours, minutes] = (activity.time || '18:00').split(':').map(Number);
      const completedAt = new Date(year, month - 1, day, hours, minutes);

      return {
        id: activity.id,
        completed_at: completedAt.toISOString(),
      };
    });
};

export const repairAthleteSessionTimestamps = async (userId) => {
  if (!userId) return { checked_count: 0, repaired_count: 0 };

  const response = await axios.post(`${API}/sessions/repair-timestamps`, {
    user_id: userId,
    custom_activities: buildCustomActivityRepairItems(userId),
  });

  return response.data;
};

export default repairAthleteSessionTimestamps;